module.exports = __webpack_public_path__ + "static/3-278e86636b5676c246cb08329cb36de4.svg";